<h2 mat-dialog-title>Conferma del numero progressivo</h2>

    <mat-dialog-content>
      <p>Stai per inviare il documento con numero progressivo {{ progressive_number }}.</p>
      <p class="mt-2">Confermi?</p>
      <mat-checkbox [(ngModel)]="confirmed">Sì, il numero progressivo è corretto.</mat-checkbox>
      <!-- if invoice is healthcare -->
      <p class="mt-3" *ngIf="healthcare_invoice === true">Nota: Questo documento riguarda una prestazione sanitaria. Verrà emesso come Fattura cartacea e non verrà inviato allo SDI.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Torna indietro e modifica</button>
      <button mat-raised-button color="primary" [disabled]="!confirmed" (click)="confirm()">
        <mat-icon>check</mat-icon>
        Confermo
      </button>
    </mat-dialog-actions>
